import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';

import { retryAuthentication } from '../../utils/epics/retryAuthentication';
import { types as actions, viewedUserLinkAction } from '../../reducers/actions';
import { UserService } from '../../services';

export default function (action$, store) {
  return action$.pipe(
    ofType(actions.VIEW_LINK),
    switchMap(action =>
      UserService.viewUserLink(action.email, action.siteId, action.orgId, store).pipe(
        map(data => viewedUserLinkAction(data)),
        catchError(retryAuthentication(action$, 'epics/users/viewUserLink'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/users/viewUserLink.js